import styled from "styled-components";

export const AmountText = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  margin: 0.5rem auto;
  white-space: nowrap;
  > p {
    color: ${({ theme }) => theme.palette.common.text.secondary};
    font-size: 13px;

    margin: 0px;
    display: flex;
    width: 50%;
  }
`;

export const Reward = styled.div`
  display: flex;
  flex-direction: column;

  p {
    color: ${({ theme }) => theme.palette.common.text.secondary};
    font-size: 13px;
    margin: 0;
  }
  input[type="range"] {
    overflow: hidden;
  }

  input {
    color: ${({ theme }) => theme.palette.card.text.primary};
  }
`;

export const AmountDiv = styled.div`
  justify-content: center;
  display: flex;
  p {
    color: ${({ theme }) => theme.palette.common.text.secondary};
    font-size: 13px;
    margin: 0;
  }
`;

export const InputDiv = styled.div`
  background: ${(props) => props.theme.palette.card.background.primary} 0% 0%
    no-repeat padding-box;
  opacity: 1;
  display: flex;
  border: none;
  padding: 12px;
  width: 100%;
  align-items: center;
  max-height: 42px;
  border-radius: 2px;
  :focus-visible {
  }
`;

export const TextAlign = styled.div`
  width: 100%;
  color: ${({ theme }) => theme.palette.common.text.secondary};
  text-align: end;
  display: block !important;
  align-items: center;
  height: 20px;
  > p {
    color: ${(props) => props.theme.palette.common.text.secondary};
    font-size: 12.5px;
    width: 100%;
  }
`;

export const InputCurrency = styled.input`
  border: none;
  width: 100%;
  font-size: 16px;
  font-weight: 600;
  outline: none !important;
  background-color: ${(props) => props.theme.palette.card.background.primary};
  color: ${(props) => props.theme.palette.card.text.primary};
  font-weight: 800;
  letter-spacing: 2px;
  font-size: 14px;

  -moz-appearance: textfield;
  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
`;

export const Max = styled.button`
  color: ${({ theme }) => theme.palette.common.text.secondary};
  font-size: 14px;
  display: contents;
  font-weight: 600;
  border: none;
  margin: 0px;
  letter-spacing: 1px;
  text-transform: capitalize;
  width: 100%;
`;
